module.exports = __webpack_public_path__ + "img/s3-2.5737fc05.jpg";